import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import Api from '../config'

Vue.use(Vuex)

const state = {
  pageTitle:'会员中心',
  isLogin:false,
  bgc: '',
  vouchersState:'0',
  pageType:"",
  storeInfo:[],
  selectStore:false,
  gift:'',
  setPath:''
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js